document.addEventListener("DOMContentLoaded", function () {
  var accordionItems = document.querySelectorAll(".custom-accordion-item");

  accordionItems.forEach((item) => {
    var header = item.querySelector(".custom-accordion-header");
    var content = item.querySelector(".custom-accordion-content");
    var icon = header.querySelector(".custom-accordion-icon");

    // Initially, open all accordion items
    item.classList.add("active");
    content.classList.add("show");
    icon.textContent = "-";

    header.addEventListener("click", () => {
      item.classList.toggle("active");
      content.classList.toggle("show");

      if (item.classList.contains("active")) {
        icon.textContent = "-";
      } else {
        icon.textContent = "+";
      }
    });
  });

  setMaxValueFromSchema();
  setTooltipLabelFromSchema();
});

function updateSubtotal(variantId, unitPrice) {
  unitPrice = unitPrice.replace(/,/g, ".");
  var quantityInput = document.getElementById("price-input-" + variantId);
  var subtotalElement = document.getElementById("subtotal-" + variantId);
  var subtotalWithTaxElement = document.getElementById(
    "subtotal-with-tax-" + variantId
  );
  var quantity = parseInt(quantityInput.value, 10);

  if (quantity < 0) {
    return;
  }

  var total = quantity * parseFloat(unitPrice);
  subtotalElement.setAttribute("data-subtotal", total.toFixed(2));
  subtotalElement.textContent = formatMoney(total);

  // Update tax-included price
  var taxRate = 1.19; // Example tax rate of 19%
  var totalWithTax = total * taxRate;
  subtotalWithTaxElement.setAttribute(
    "data-subtotal-with-tax",
    totalWithTax.toFixed(2)
  );
  subtotalWithTaxElement.textContent = formatMoney(totalWithTax);

  updateTotal();
  updateRangePosition(variantId);
  if (quantity == 0) {
    const tooltip = document.getElementById(`range-tooltip-${variantId}`);
    const label = tooltip.getAttribute("data-label");
    tooltip.innerHTML = label;
  } else {
    updateRangeText(variantId);
  }
}

function updateTotal() {
  var subtotalElements = document.querySelectorAll(".price.subtotal");
  var subtotalWithTaxElements = document.querySelectorAll(
    ".price-with-tax.subtotal"
  );
  var total = 0;
  var totalWithTax = 0;

  subtotalElements.forEach(function (element) {
    var subtotalValue = parseFloat(element.getAttribute("data-subtotal"));
    total += subtotalValue;
  });

  subtotalWithTaxElements.forEach(function (element) {
    var subtotalWithTaxValue = parseFloat(
      element.getAttribute("data-subtotal-with-tax")
    );
    totalWithTax += subtotalWithTaxValue;
  });

  var grandTotalElement = document.getElementById("grand-total");
  var grandTotalWithTaxElement = document.getElementById(
    "grand-total-with-tax"
  );
  grandTotalElement.textContent = formatMoney(total);
  grandTotalWithTaxElement.textContent = formatMoney(totalWithTax);
}

function addProductsToCart() {
  var formData = { items: [] };

  var quantityInputs = document.querySelectorAll(".quantity__input");
  quantityInputs.forEach((input) => {
    var variantId = input.getAttribute("data-variant");
    var quantity = parseInt(input.value);

    if (quantity > 0) {
      formData.items.push({
        id: variantId,
        quantity: quantity,
      });
    }
  });

  if (formData.items.length <= 0) {
    return;
  }

  fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(formData),
  })
    .then((response) => {
      window.location.href = "/cart";
    })
    .catch((error) => {});
}

function updateQuantity(variantId, quantity) {
  var quantityInput = document.getElementById("price-input-" + variantId);
  quantityInput.value = quantity;
  var event = new Event("change");
  quantityInput.dispatchEvent(event);
}

function plusButtonClicked(variantId, minQuantities) {
  let minQuantitiesArray = minQuantities
    ? minQuantities.split(",").map(Number)
    : [];

  let quantityInput = document.getElementById("price-input-" + variantId);
  let currentQuantityInputValue = parseInt(quantityInput.value);
  let inputIncreaseBy = minQuantitiesArray.length > 0 ? minQuantitiesArray[0] : 1;

  if (minQuantitiesArray.length > 0) {
    for (let i = 0; i < minQuantitiesArray.length; i++) {
      let first = minQuantitiesArray[i];
      let second = minQuantitiesArray[i + 1];

      if (currentQuantityInputValue === first) {
        inputIncreaseBy = first;
        break;
      }

      if (second !== undefined) {
        if (currentQuantityInputValue === second) {
          inputIncreaseBy = second;
          break;
        }

        if (
          currentQuantityInputValue > first &&
          currentQuantityInputValue < second
        ) {
          inputIncreaseBy = first;
          break;
        }
      }
    }

    if (
      currentQuantityInputValue >=
      minQuantitiesArray[minQuantitiesArray.length - 1]
    ) {
      inputIncreaseBy = minQuantitiesArray[minQuantitiesArray.length - 1];
    }

    let quantityValue =
      Math.floor(currentQuantityInputValue / inputIncreaseBy) * inputIncreaseBy;

    let newValue = quantityValue + inputIncreaseBy;
    quantityInput.value = newValue;
  } else {
    quantityInput.value = currentQuantityInputValue + 1;
  }

  var event = new Event("change");
  quantityInput.dispatchEvent(event);
}

function minusButtonClicked(variantId, minQuantities) {
  let minQuantitiesArray = minQuantities
    ? minQuantities.split(",").map(Number)
    : [];

  let quantityInput = document.getElementById("price-input-" + variantId);
  let currentQuantityInputValue = parseInt(quantityInput.value);
  let inputDecreaseBy = minQuantitiesArray.length > 0 ? minQuantitiesArray[0] : 1;

  if (currentQuantityInputValue == 0) {
    return;
  }

  if (minQuantitiesArray.length > 0) {
    for (let i = 0; i < minQuantitiesArray.length; i++) {
      let first = minQuantitiesArray[i];
      let second = minQuantitiesArray[i + 1];

      if (
        currentQuantityInputValue >= first &&
        currentQuantityInputValue <= second
      ) {
        inputDecreaseBy = first;
        break;
      }
    }

    if (
      currentQuantityInputValue >
      minQuantitiesArray[minQuantitiesArray.length - 1]
    ) {
      inputDecreaseBy = minQuantitiesArray[minQuantitiesArray.length - 1];
    }

    let quantityValue =
      Math.floor(currentQuantityInputValue / inputDecreaseBy) * inputDecreaseBy;

    let reminder = currentQuantityInputValue % inputDecreaseBy;
    let newValue = reminder == 0 ? quantityValue - inputDecreaseBy : quantityValue;

    quantityInput.value = newValue;
  } else {
    quantityInput.value = currentQuantityInputValue > 0 ? currentQuantityInputValue - 1 : 0;
  }

  var event = new Event("change");
  quantityInput.dispatchEvent(event);
}

function formatMoney(amount) {
  let formattedPrice = new Intl.NumberFormat(Shopify.currency.active, {
    style: "currency",
    currency: Shopify.currency.active,
  }).format(amount);
  return formattedPrice;
}

//slider related codes
function handleSliderUpdate(event, variantId) {
  let sliderValue = event.target.value;
  const jsonString = event.target.getAttribute("data-schema");
  let discountSchema = JSON.parse(jsonString);

  updateQuantityInput(discountSchema, sliderValue, variantId);
  updateRangeText(variantId);
}

function updateQuantityInput(discountSchema, sliderValue, variantId) {
  let quantityInput = document.getElementById("price-input-" + variantId);
  for (const container of discountSchema.productContainers) {
    if (
      sliderValue >= container.sliderMin &&
      sliderValue <= container.sliderMax
    ) {
      let multiplier = Math.abs(container.sliderMin - sliderValue) + 1;
      quantityInput.value = multiplier * container.minQuantity;
    }
  }
  const event = new Event("change");
  quantityInput.dispatchEvent(event);
}

function setMaxValueFromSchema() {
  const rangeInputs = document.querySelectorAll('input[type="range"]');
  rangeInputs.forEach((input) => {
    const schema = JSON.parse(input.getAttribute("data-schema"));
    const discountSchema = initialProcessDiscountSchema(schema);
    input.max = discountSchema.maxSliderValue;
    input.setAttribute("data-schema", JSON.stringify(discountSchema));
  });
}

function setTooltipLabelFromSchema() {
  const tooltips = document.querySelectorAll(".range-tooltip");
  tooltips.forEach((tooltip) => {
    const schema = JSON.parse(tooltip.getAttribute("data-schema"));
    const label = schema.productContainers[0].name;
    tooltip.setAttribute("data-label", label);
    tooltip.innerHTML = label;
  });
}

function initialProcessDiscountSchema(discountSchema) {
  for (let i = 0; i < discountSchema.productContainers.length - 1; i++) {
    discountSchema.productContainers[i].maxQuantity =
      discountSchema.productContainers[i + 1].minQuantity - 1;
    discountSchema.productContainers[i].sliderMax =
      discountSchema.productContainers[i + 1].sliderMin - 1;
  }

  const lastElement =
    discountSchema.productContainers[
      discountSchema.productContainers.length - 1
    ];
  lastElement.sliderMax = lastElement.sliderMin;
  lastElement.maxQuantity = lastElement.minQuantity;

  // Initialize a variable to keep track of the maximum slider value
  let maxSliderValue = -Infinity;

  // Loop through the array to find the maximum slider value
  discountSchema.productContainers.forEach((item) => {
    if (item.sliderMax > maxSliderValue) {
      maxSliderValue = item.sliderMax;
    }
  });

  // Add maxSliderValue to the discountSchema
  discountSchema.maxSliderValue = maxSliderValue;

  return discountSchema;
}

function updateRangeText(variantId) {
  // Retrieve elements by variantId
  const quantityInput = document.getElementById(`price-input-${variantId}`);
  const rangeText = document.getElementById(`range-text-${variantId}`);
  const rangeTooltip = document.getElementById(`range-tooltip-${variantId}`);
  const rangeInput = document.getElementById(`range-slider-${variantId}`);

  // Ensure the elements are found
  if (!quantityInput || !rangeText || !rangeTooltip || !rangeInput) {
    console.error("One or more elements could not be found.");
    return;
  }

  // Calculate adjusted value
  const percentageValue = (rangeInput.value / rangeInput.max) * 100;
  let adjustedValue;

  if (percentageValue <= 49) {
    adjustedValue = percentageValue + 2 - 0.02 * percentageValue;
  } else {
    adjustedValue = percentageValue - 0.04 * percentageValue;
  }
  if (rangeInput.max < 15 && percentageValue <= 48) {
    adjustedValue = percentageValue - 6;
  }
  rangeText.style.left = adjustedValue + "%";

  let negNewVal = -1 * (rangeInput.value / rangeInput.max) * 100;
  rangeText.style.transform = "translate(" + negNewVal + "%, 0px)";
  rangeTooltip.style.left = adjustedValue + "%";
  rangeTooltip.style.transform = "translate(" + negNewVal + "%, 0px)";

  // Calculate the current container and update tooltip text
  let currentContainer = getCurrentContainer(variantId);
  let quantity = quantityInput.value;

  const currentQuantity = parseInt(quantity / currentContainer.minQuantity);

  if (currentQuantity === 1) {
    rangeTooltip.innerHTML = `${currentQuantity} ${currentContainer.name}`;
  } else {
    rangeTooltip.innerHTML = `${currentQuantity} ${
      currentContainer.pluralName || currentContainer.name
    }`;
  }
}

function getCurrentContainer(variantId) {
  let quantity = document.getElementById(`price-input-${variantId}`).value;
  const rangeInput = document.getElementById(`range-slider-${variantId}`);
  const jsonString = rangeInput.getAttribute("data-schema");
  let discountSchema = JSON.parse(jsonString);
  
  // Iterate through the containers to find a match
  for (const container of discountSchema.productContainers) {
    if (quantity >= container.minQuantity && quantity <= container.maxQuantity) {
      return container;
    }
  }
  
  // If no match is found, return the last container
  return discountSchema.productContainers[discountSchema.productContainers.length - 1];
}

function updateRangePosition(variantId) {
  const rangeInput = document.getElementById(`range-slider-${variantId}`);
  const quantityInput = document.getElementById(`price-input-${variantId}`);
   if (!rangeInput || !quantityInput) {
    return;
  }
  if (quantityInput.value == 0) {
    rangeInput.value = 0;
    return;
  }
  if (quantityInput.value == 1) {
    rangeInput.value = 1;
    return;
  }
  let currentContainer = getCurrentContainer(variantId);
  rangeInput.value =
    Math.floor(quantityInput.value / currentContainer.minQuantity) +
    currentContainer.sliderMin;
}
